async function requestJson(path, options) {
  const response = await fetch(path, options);
  const payload = await response.json().catch(() => ({}));

  if (!response.ok) {
    const error = new Error(payload.message || "Request failed.");
    error.status = response.status;
    error.requiresAdminLogin = payload.requiresAdminLogin;
    throw error;
  }

  return payload;
}

function buildAdminHeaders(adminCredentials) {
  if (
    !adminCredentials ||
    !adminCredentials.username ||
    !adminCredentials.password
  ) {
    return {"Content-Type": "application/json"};
  }

  return {
    "Content-Type": "application/json",
    Authorization: `Basic ${window.btoa(
      `${adminCredentials.username}:${adminCredentials.password}`
    )}`
  };
}

export function fetchPublishedBlogs() {
  return requestJson("/api/blogs");
}

export function fetchAdminBlogs(adminCredentials) {
  return requestJson("/api/admin/blogs", {
    headers: buildAdminHeaders(adminCredentials)
  });
}

export function createBlogPost(input, adminCredentials) {
  return requestJson("/api/admin/blogs", {
    method: "POST",
    headers: buildAdminHeaders(adminCredentials),
    body: JSON.stringify(input)
  });
}

export function updateBlogPost(id, input, adminCredentials) {
  return requestJson(`/api/admin/blogs/${id}`, {
    method: "PUT",
    headers: buildAdminHeaders(adminCredentials),
    body: JSON.stringify(input)
  });
}

export async function deleteBlogPost(id, adminCredentials) {
  const response = await fetch(`/api/admin/blogs/${id}`, {
    method: "DELETE",
    headers: buildAdminHeaders(adminCredentials)
  });

  if (!response.ok) {
    const payload = await response.json().catch(() => ({}));
    const error = new Error(payload.message || "Delete failed.");
    error.status = response.status;
    error.requiresAdminLogin = payload.requiresAdminLogin;
    throw error;
  }
}

export function likeBlogPost(id) {
  return requestJson(`/api/blogs/${id}/like`, {
    method: "POST"
  });
}

export function commentOnBlogPost(id, input) {
  return requestJson(`/api/blogs/${id}/comments`, {
    method: "POST",
    headers: {"Content-Type": "application/json"},
    body: JSON.stringify(input)
  });
}
